import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { stringify } from 'hub-http/helpers/params';
export function formatCustomTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const displaySeconds = Math.floor(seconds % 60);
  return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${displaySeconds < 10 ? '0' : ''}${displaySeconds}`;
}
export function parseCustomTime(value) {
  if (value.includes(':')) {
    const parts = value.split(':');
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (parts.length === 3) {
      hours = parseInt(parts[0], 10);
      minutes = parseInt(parts[1], 10);
      seconds = parseInt(parts[2], 10);
    } else if (parts.length === 2) {
      minutes = parseInt(parts[0], 10);
      seconds = parseInt(parts[1], 10);
    } else if (parts.length === 1) {
      seconds = parseInt(parts[0], 10);
    }
    return hours * 60 * 60 + minutes * 60 + seconds;
  }
  const parsedValue = parseInt(value, 10);
  return Number.isNaN(parsedValue) ? null : parsedValue;
}
const isLocal = () => enviro.getShort('video_player') === 'local';
export function stringifyQueryParams(queryObj) {
  const truthyQueryObj = {};
  Object.keys(queryObj).forEach(key => {
    if (queryObj[key]) {
      truthyQueryObj[key] = queryObj[key];
    }
  });
  return stringify(truthyQueryObj);
}
function queryToString(params) {
  return typeof params === 'object' && Object.keys(params).length ? `?${stringifyQueryParams(params)}` : '';
}
export function getEmbedIframeDomain() {
  if (isLocal()) {
    return getFullUrl('local');
  }
  return getFullUrl('app');
}
export function getEmbedIframeUrl(portalId, videoId, params = {}) {
  const path = `video/${portalId}/id/${videoId}`;
  return `${getEmbedIframeDomain()}/${path}${queryToString(params)}`;
}